import { Req } from "@larner.dev/req";
import { getRuntimeCmsApiUrl } from "./runtimeApiUrl";

export const cmsRequest = new Req(getRuntimeCmsApiUrl());
cmsRequest.headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  Authorization: `Bearer ${import.meta.env.VITE_CMS_API_TOKEN}`,
};
cmsRequest.debug = !!import.meta.env.VITE_REQUEST_DEBUG;
